<header class="bg-white shadow position-fixed w-100 z-3">
  <div class="container">
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container-fluid p-0">
        <a class="navbar-brand d-flex align-items-center company-logo" [routerLink]="['/']">
          <img src="/assets/images/logo.png" alt="Logo" width="30px" height="30px" />
        </a>

        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul class="navbar-nav primary-menu">
            <li class="nav-item">
              <a
                class="nav-link text-dark px-4 cursor-pointer"
                (click)="scrollToId('banner-module')"
                >Home</a
              >
            </li>

            <li class="nav-item">
              <a class="nav-link text-dark px-4 cursor-pointer" (click)="scrollToId('core-module')"
                >Modules</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link text-dark px-4 cursor-pointer" (click)="scrollToId('why-choose')"
                >Features</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link text-dark px-4 cursor-pointer" (click)="scrollToId('testimonials')"
                >Clients</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link text-dark px-4 cursor-pointer" (click)="scrollToId('faq')">Faq</a>
            </li>
          </ul>
          <a
            *ngIf="!currentUser"
            routerLink="/login"
            class="btn btn-outline-primary px-4 ms-lg-5 ms-0"
          >
            Sign In</a
          >
        </div>
        <!-- <a href="{{ route('login-form') }}" class="btn btn-outline-primary px-4 d-none d-md-block"
            >Sign In</a
          > -->
      </div>
    </nav>
  </div>
</header>
